import axios from "axios";
import { getIdentityBaseUrl } from "features/auth/lib/identity";

let inFlight: Promise<string> | null = null;
export const REFRESH_PATH = "/user/refresh-token";

function getHost() {
  return getIdentityBaseUrl();
}

export async function refreshAccessToken(): Promise<string> {
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("NO_REFRESH");

    const { data } = await axios.post(`${getHost()}${REFRESH_PATH}`, null, {
      params: { refreshToken },
      headers: { Accept: "application/json" },
      withCredentials: true,
    });

    const next = data?.res ?? data?.result ?? data;

    if (!next?.accessToken) {
      throw new Error("NO_ACCESS_FROM_REFRESH");
    }

    localStorage.setItem("token", next.accessToken);
    if (next.refreshToken) {
      localStorage.setItem("refreshToken", next.refreshToken);
    }

    return next.accessToken as string;
  })();

  try {
    return await inFlight;
  } finally {
    inFlight = null;
  }
}
